import { react , useEffect, useState} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import HeaderSlogan from './HeaderSlogan';

import ReactGA from 'react-ga4';
ReactGA.initialize([{ trackingId: process.env.REACT_APP_GOOGLE_TAG }]);

const Media = () => {

    useEffect(() => {
        if (window.location.href.indexOf('localhost') == -1 && window.location.href.toLowerCase().indexOf('test.sipzee.com') == -1) {
            ReactGA.send({ hitType: "pageview", page: '/Media' });
        }
    }, []);

    const [isLoading, setisLoading] = useState(false);
    let panel;

    function buildLoadingPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50vh"
            >
                <CircularProgress color="secondary" onClick={() => setisLoading(false)} />
            </Box>
        )

    }

    if (isLoading) {
        panel = buildLoadingPanel();
    } else {
        panel =
            <div style={{display:'flex', justifyContent:'center', flexDirection:'column',padding:'10px' } }>
                <div style={{ marginTop: '15px', alignSelf: 'center', maxWidth: '600px' }}>
                    <HeaderSlogan />
                    <div>
                        <div style={{ color: 'var(--sipzee-yellow)', textAlign:'left', fontWeight:'bold', marginBottom:'10px'}} >Media</div>
                        <table style={{alignSelf:'center', width:'100%'} }>
                           
                            <tbody>
                                <tr style={{fontWeight:'bold', textAlign:'left'} }>
                                    <td>June 2022</td>
                                    <td><a target="_blank" href="https://wcrz.com/sipzee-takes-the-hassle-out-of-returning-bottles-cans/">Cars 108 WCRZ</a></td>
                                </tr>
                                <tr style={{ fontWeight: 'bold', textAlign: 'left' }}>
                                    <td>June 2022</td>
                                    <td><a target="_blank" href="https://www.freep.com/story/news/local/michigan/2022/06/04/sipzee-bottle-can-return-app-deposit-michigan/7512643001/">Detroit Free Press</a></td>
                                </tr>
                                <tr style={{ fontWeight: 'bold', textAlign: 'left' }}>
                                    <td>December 2020</td>
                                    <td><a target="_blank" href="https://www.rapidgrowthmedia.com/innovationnews/sipzee.aspx">Rapid Growth Media</a></td>
                                </tr>
                                <tr style={{ fontWeight: 'bold', textAlign: 'left' }}>
                                    <td>November 2020</td>
                                    <td><a target="_blank" href="https://www.wzzm13.com/article/news/local/michigan-life/get-paid-returnable-cans-bottle-michigan-sipzee-app/69-444b650e-45c7-4ee0-a780-b52aee598d1c">WZZM13 On Your Side</a></td>
                                </tr>
                                <tr style={{ fontWeight: 'bold', textAlign: 'left' }}>
                                    <td>November 2020</td>
                                    <td><a target="_blank" href="https://wgrd.com/new-grand-rapids-app-will-return-cans-and-bottles-for-you/">97.9 WGRD</a></td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                    </div>
                </div>
            </div>;
    }

    return (
        panel  
    )

  
}

export default Media;